import { Question } from "./question.model"

export class EssayQuestion extends Question {

  public maxLength: number;


  constructor(
    obj?: any 
  ) {

    super(obj);
    this.className = 'EssayQuestion';
    this.maxLength = obj && obj.maxLength || 320;
  
  }

}